export const KPI_DATA_CHANGED_EVENT = 'compass:kpi-data-changed';
export const KPI_DATA_CHANGED_STORAGE_KEY = 'compass.dashboard.kpi-data-changed';

export interface KpiDataChangedDetail {
  tenantName?: string;
  userId?: number;
  timestamp: number;
}

const KPI_DATA_CREATION_ROUTES = [
  /\/StudentServices\/SaveCreate(?:\?|$)/i,
  /\/StudentServices\/SaveCreateAdditionalEntries(?:\?|$)/i,
  /\/Students\/SaveBulkCreateServices(?:\?|$)/i,
  /\/StudentServiceTemplates\/(?:AddAttendees|LinkExistingStudent|SignUp)(?:\?|$)/i,
];

export const isKpiDataCreationRequest = (method?: string, url?: string): boolean =>
  method?.toLowerCase() === 'post' && Boolean(url && KPI_DATA_CREATION_ROUTES.some((route) => route.test(url)));

export const notifyKpiDataChanged = (tenantName?: string, userId?: number): void => {
  const detail: KpiDataChangedDetail = { tenantName, userId, timestamp: Date.now() };
  window.dispatchEvent(new CustomEvent<KpiDataChangedDetail>(KPI_DATA_CHANGED_EVENT, { detail }));
  window.localStorage.setItem(KPI_DATA_CHANGED_STORAGE_KEY, JSON.stringify(detail));
};
